export default __webpack_public_path__ + "static/media/Botão Voltar Web.567b4971.svg";